import { render, staticRenderFns } from "./CustomerGroupsModal.vue?vue&type=template&id=6ffc907e"
import script from "./CustomerGroupsModal.vue?vue&type=script&lang=js"
export * from "./CustomerGroupsModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroupsModal.vue?vue&type=style&index=0&id=6ffc907e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports